// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-upload[data-v-83877f24]{width:100%;height:100%;position:relative}.media-upload .media-upload-input[data-v-83877f24]{display:none}.media-upload .media-upload-button[data-v-83877f24]{cursor:pointer;width:100%;height:100%;position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
